import React from 'react'

import Alert from 'components/ui/alert'
import InlineLink from 'components/ui/inline-link'

const InsightsTrialAlert = (): React.ReactNode => (
  <Alert icon="warning" status="warning">
    Analytics offer powerful insights about your activity on DISCO. Analytics
    are available on <InlineLink to="/pricing">Plus and Pro plans.</InlineLink>
  </Alert>
)

export default InsightsTrialAlert
